import type { marked } from 'marked';

import type { RendererFn } from '../type';

export const strong: RendererFn<marked.Tokens.Strong> = (
  { tokens },
  { parse, key }
) => {
  return <strong key={key}>{parse(tokens)}</strong>;
};
